/* RESPONSIBLE TEAM: team-ai-agent */
import FinAiAgentSalesPerformanceRoute from '../sales/performance';

export default class FinAIAgentAnalyzeSalesPerformanceRoute extends FinAiAgentSalesPerformanceRoute {}
